import {
    INVALIDATE_ENDPOINT,
    REQUEST_ENDPOINT,
    RECEIVE_ENDPOINT,
    EDIT_FORM,
    ADD_KEY_VALUE,
    SET_LIST_COUNT,
    SET_CURRENT_LIST_PAGE,
    SET_FILTER,
    SET_ITEMS_PER_PAGE
} from '../actions/constants'
import passThruFilter from '../components/utilities/passThruFilter'

export default function endpoints(state = {}, action) {
    switch (action.type) {

        case INVALIDATE_ENDPOINT:
            return state.map(endpoint => {

                if (endpoint.id === action.id) {
                    return Object.assign({}, endpoint, {
                        isFetching: false,
                        didInvalidate: true
                    })
                }

                return endpoint
            })

        case REQUEST_ENDPOINT:
            return state.map(endpoint => {

                if (endpoint.id === action.id) {
                    return Object.assign({}, endpoint, {
                        isFetching: true,
                        didInvalidate: false
                    })
                }

                return endpoint
            })

        case RECEIVE_ENDPOINT:
            return state.map((endpoint) => {
                if (endpoint.id === action.id) {

                    // Take into account the current filter when determining the new page count
                    let filteredList = passThruFilter(action.list, endpoint.filter)

                    // When an endpoint is recieved and data is refreshed, need to recalculated paging
                    let newListLength = filteredList.length
                    let itemsPerPage = endpoint.itemsPerPage // current items per page
                    let newPageCount = Math.ceil(newListLength / itemsPerPage) // recalculate page amount
                    let currentListPage = endpoint.currentListPage
                    /**
                     *  If the new page count is lesser than the current page, 
                        for example when deleting the last item on the last page, we need to go to the
                        new last page, eg deleting the last remaining item in page 5 would result in only
                        having 4 pages, we need to set the current page to 4
                        currentListPage is 0 index based, use '>=' comparator
                    */

                    if (currentListPage >= newPageCount) {
                        currentListPage = newPageCount - 1
                    }

                    if (endpoint.apiPaged) {
                        filteredList = action.list
                        newListLength = endpoint.listCount
                        itemsPerPage = endpoint.itemsPerPage // current items per page
                        newPageCount = Math.ceil(newListLength / itemsPerPage) // recalculate page amount
                        currentListPage = endpoint.currentListPage

                        if (currentListPage >= newPageCount) {
                            currentListPage = newPageCount - 1
                        }
                        if (currentListPage < 0) {
                            currentListPage = 0
                        }
                    }

                    return Object.assign({}, endpoint, {
                        isFetching: false,
                        didInvalidate: false,
                        list: action.list,
                        listCount: newListLength,
                        listPages: newPageCount,
                        currentListPage: currentListPage,
                        initialized: true, // The first time an endpoint is received, set to initialized=true
                        lastUpdated: action.receivedAt
                    })
                }

                return endpoint
            })

        case EDIT_FORM:
            return state.map(endpoint => {
                if (endpoint.id === action.id) {

                    let nform = []
                    let nid = endpoint.form.length + 1

                    let names = endpoint.form.map(field => field.name)
                    // names.push('id')

                    action.form.forEach((field) => {
                        for (var n in field) {
                            if (names.indexOf(n) === -1) {
                                let ntyp = null
                                try {
                                    ntyp = typeof JSON.parse(field[n])
                                } catch (e) {
                                    ntyp = 'string'
                                }
                                nform.push({
                                    id: nid,
                                    name: n,
                                    type: ntyp,
                                    // type: typeof field[n],
                                    value: null
                                })
                            }

                            nid++
                            names.push(n)
                        }
                    })

                    return Object.assign({}, endpoint, {
                        form: endpoint.form.concat(nform)
                    })
                }

                return endpoint
            })

        case ADD_KEY_VALUE:
            return state.map(endpoint => {
                if (endpoint.id === action.id) {

                    let remList = null
                    let listItem = null

                    if (action.listId) {
                        remList = endpoint.list.filter(l => l.id !== action.listId)
                        listItem = endpoint.list.find(l => l.id === action.listId)
                    } else {
                        remList = endpoint.list
                        listItem = endpoint.form
                    }

                    let newObject = {}
                    let ct = Math.floor(Math.random() * 100).toString()

                    newObject[action.listProp] = listItem[action.listProp].replace(
                        '}',
                        ',"defaultKey_' + ct +
                        '":"defaultValue_' + ct + '"}'
                    )

                    let newList = Object.assign({}, listItem, newObject)

                    if (action.listId) {
                        return Object.assign({}, endpoint, {
                            list: remList.concat([newList])
                        })
                    } else {
                        return Object.assign({}, endpoint, {
                            form: newList
                        })
                    }
                }

                return endpoint
            })

        case SET_LIST_COUNT:
            return state.map(endpoint => {
                if (endpoint.id === action.id) {
                    let ipp = endpoint.itemsPerPage
                    let lp = Math.ceil(action.count / ipp)
                    return Object.assign({}, endpoint, {
                        listCount: action.count,
                        listPages: lp
                    })
                }

                return endpoint
            })

        case SET_ITEMS_PER_PAGE:
            return state.map(endpoint => {
                if (endpoint.id === action.id) {
                    let ipp = action.itemsPerPage
                    return Object.assign({}, endpoint, {
                        itemsPerPage: ipp,
                        listPages: Math.ceil(endpoint.listCount / ipp),
                        currentListPage: 0,
                    })
                }

                return endpoint
            })

        case SET_CURRENT_LIST_PAGE:
            return state.map(endpoint => {
                if (endpoint.id === action.id) {
                    return Object.assign({}, endpoint, {
                        currentListPage: action.page
                    })
                }

                return endpoint
            })

        case SET_FILTER:
            return state.map(endpoint => {
                if (endpoint.id === action.id) {

                    let { listCount, filter } = endpoint
                    //let currentList = passThruFilter( list, filter )
                    let lc = listCount;//currentList.length

                    return Object.assign({}, endpoint, {
                        filter: Object.assign({}, endpoint.filter, action.filter),
                        listCount: lc,
                        listPages: Math.ceil(lc / endpoint.itemsPerPage),
                        currentListPage: 0
                    })
                }

                return endpoint
            })

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/endpoints.js